import { render, staticRenderFns } from "./bill.vue?vue&type=template&id=277c2c80&scoped=true"
import script from "./bill.vue?vue&type=script&lang=js"
export * from "./bill.vue?vue&type=script&lang=js"
import style0 from "./bill.vue?vue&type=style&index=0&id=277c2c80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277c2c80",
  null
  
)

export default component.exports